import React, { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Button, Paper, Tooltip, useTheme } from "@mui/material";
import { Check } from "@mui/icons-material";
interface Props {
  shortUrl: string;
}
const CopyToClipboard: React.FC<Props> = ({ shortUrl }: Props) => {
  const [copied, setCopied] = useState(false);
  const theme = useTheme();
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shortUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <Paper
      sx={{
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        border: "1px solid red",
        p: 2
      }}
      variant="outlined"
    >
      <a
        href={shortUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          textDecoration: "none",
          color: theme.palette.text.primary
        }}
      >
        {shortUrl}
      </a>
      <Tooltip title="Copy to clipboard">
        <Button onClick={handleCopy} sx={{ minWidth: "30px" }}>
          {!copied ? (
            <ContentCopyIcon sx={{ height: "20px", color: theme.palette.text.primary }} />
          ) : (
            <Check sx={{ height: "20px", color: theme.palette.text.primary }} />
          )}
        </Button>
      </Tooltip>
    </Paper>
  );
};

export default CopyToClipboard;
